import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/company-logo.svg";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      {/* Mobile Header */}
      <div className="bg-gray-800 h-14 flex items-center justify-between px-4 text-white md:hidden shadow-md">
        {/* Logo */}
        <div className="flex-shrink-0">
          <a href="/">
            <img src={logo} alt="Logo" className="h-10 w-auto" />
          </a>
        </div>

        {/* Hamburger Menu */}
        <button
          className="text-white text-2xl focus:outline-none"
          onClick={toggleMenu}
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMenuOpen && (
        <div className="bg-gray-900 text-white py-4 md:hidden shadow-lg">
          <nav>
            <ul className="flex flex-col items-center space-y-4">
              <li>
                <Link
                  to="/"
                  className="hover:text-gray-400"
                  onClick={toggleMenu}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="hover:text-gray-400"
                  onClick={toggleMenu}
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="hover:text-gray-400"
                  onClick={toggleMenu}
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="hover:text-gray-400"
                  onClick={toggleMenu}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
          <div className="mt-6 text-center">
            <p className="text-sm font-bold">
              Contact: +91 98453 85842
            </p>
            <p className="text-sm font-bold">
              Email: globaleximblr@gmail.com
            </p>
          </div>
        </div>
      )}

      {/* Desktop Header */}
      <div className="hidden md:flex flex-col text-gray-700 pt-4">
        <div className="container mx-auto flex justify-between items-center px-4">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/">
              <img
                src={logo}
                alt="Logo"
                className="h-12 md:h-16 lg:h-18 w-auto"
              />
            </a>
          </div>

          {/* Navigation Links */}
          <nav>
            <ul className="flex space-x-6">
              <li>
                <Link to="/" className="hover:text-gray-500">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-gray-500">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-gray-500">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-gray-500">
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Contact Information */}
        <div className="text-black text-center mt-1 font-bold">
          <p>Contact : +91 98453 85842 | Email : globaleximblr@gmail.com </p>
          <div className="border-b-2 border-black w-full mt-2"></div>
        </div>
      </div>
    </header>
  );
};

export default Header;
